export default "__VITE_ASSET__DunB01Y4__"